import { Outlet } from "react-router-dom";
import { brand } from "@/config/brand";

export function RootLayout() {
  return (
    <div className="bg-background text-foreground min-h-screen">
      <header className="flex items-center justify-between border-b px-6 py-3">
        <span className="font-semibold">{brand.name}</span>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
